import { MarkdownHeadingPreset } from "@/constants/componentPresets";
import { ColorType } from "@/theme/colors";
import { FontWeight } from "@/theme/typography";
import type {
  MarkdownHeadingLevel,
  MarkdownHeadingPresetConfig,
} from "./markdown-heading-types";

export const DEFAULT_MARKDOWN_HEADING_PRESET = MarkdownHeadingPreset.Level1;

export const MARKDOWN_HEADING_PRESET_CONFIGS: Record<
  MarkdownHeadingPreset,
  MarkdownHeadingPresetConfig
> = {
  [MarkdownHeadingPreset.Level1]: {
    size: 30,
    weight: FontWeight.Heavy,
    color: ColorType.White,
    opacity: 1,
    marginTopPx: 24,
    marginBottomPx: 16,
    accentBar: { widthPx: 4, color: ColorType.Accent },
  },
  [MarkdownHeadingPreset.Level2]: {
    size: 23,
    weight: FontWeight.Bold,
    color: ColorType.Accent,
    opacity: 0.95,
    marginTopPx: 22,
    marginBottomPx: 12,
  },
  [MarkdownHeadingPreset.Level3]: {
    size: 19,
    weight: FontWeight.Bold,
    color: ColorType.White,
    opacity: 0.95,
    marginTopPx: 18,
    marginBottomPx: 10,
  },
  [MarkdownHeadingPreset.Level4]: {
    size: 17,
    weight: FontWeight.SemiBold,
    color: ColorType.White,
    opacity: 0.88,
    marginTopPx: 16,
    marginBottomPx: 8,
  },
  [MarkdownHeadingPreset.Level5]: {
    size: 14,
    weight: FontWeight.SemiBold,
    color: ColorType.Accent,
    opacity: 0.85,
    marginTopPx: 14,
    marginBottomPx: 6,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  [MarkdownHeadingPreset.Level6]: {
    size: 12,
    weight: FontWeight.Medium,
    color: ColorType.White,
    opacity: 0.55,
    marginTopPx: 12,
    marginBottomPx: 6,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
};

export const MARKDOWN_HEADING_PRESET_BY_LEVEL: Record<
  MarkdownHeadingLevel,
  MarkdownHeadingPreset
> = {
  1: MarkdownHeadingPreset.Level1,
  2: MarkdownHeadingPreset.Level2,
  3: MarkdownHeadingPreset.Level3,
  4: MarkdownHeadingPreset.Level4,
  5: MarkdownHeadingPreset.Level5,
  6: MarkdownHeadingPreset.Level6,
};
